export default {"src":"/_next/static/image/public/home/shipping-logo.f96f6dee3ed09b411fd15cdc96c6a91d.svg","height":172,"width":172};